/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pt-cascader-node.vue?vue&type=template&id=4d3f86c0&scoped=true&"
import script from "./pt-cascader-node.vue?vue&type=script&lang=ts&"
export * from "./pt-cascader-node.vue?vue&type=script&lang=ts&"
import style0 from "./pt-cascader-node.vue?vue&type=style&index=0&id=4d3f86c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3f86c0",
  null
  
)

export default component.exports